import { randomNumber } from '../../../../utilities/randomNumber.util'
import { TitrateConstants } from './titrate.constants'
import { ITitrateAction, ITitrateState } from './titrate.types'

export const initialTitrateState: ITitrateState = {
  key: randomNumber().toString(),
  date: '',
  time: '',
  pta: false,
  assessedBy: null,
  rolePerforming: null,
  rolePerformingPNNV: null,
  medication: null,
  otherOption: '',
  newDose: '',
  rate: null,
  ratePNNV: null,
  route: null,
  routePNNV: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  updateInputRows: false,
  addToTimeline: false,
  type: 'Titrate',
  isEkgImport: null,
  nemsisCode: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
}

export function titrateReducer(state: ITitrateState = initialTitrateState, action: ITitrateAction): ITitrateState {
  switch (action.type) {
    case TitrateConstants.SET_DATE:
      return { ...state, date: action.date }
    case TitrateConstants.SET_TIME:
      return { ...state, time: action.time }
    case TitrateConstants.SET_DATE_TIME:
      return { ...state, date: action.date, time: action.time }
    case TitrateConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case TitrateConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case TitrateConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case TitrateConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case TitrateConstants.SET_MEDICATION:
      return { ...state, medication: action.medication }
    case TitrateConstants.SET_OTHER_OPTION:
      return { ...state, otherOption: action.otherOption }
    case TitrateConstants.SET_NEW_DOSE:
      return { ...state, newDose: action.newDose }
    case TitrateConstants.SET_RATE:
      return { ...state, rate: action.rate }
    case TitrateConstants.SET_RATE_PNNV:
      return { ...state, ratePNNV: action.ratePNNV }
    case TitrateConstants.SET_ROUTE:
      return { ...state, route: action.route }
    case TitrateConstants.SET_ROUTE_PNNV:
      return { ...state, routePNNV: action.routePNNV }
    case TitrateConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case TitrateConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case TitrateConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case TitrateConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case TitrateConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case TitrateConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case TitrateConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case TitrateConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case TitrateConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case TitrateConstants.SET_TITRATE_STATE:
      return { ...action.titrate, updateInputRows: true }
    case TitrateConstants.RESET_TITRATE_STATE:
      return {
        key: randomNumber().toString(),
        date: '',
        time: '',
        pta: false,
        assessedBy: null,
        rolePerforming: null,
        rolePerformingPNNV: null,
        medication: null,
        otherOption: '',
        newDose: '',
        rate: null,
        ratePNNV: null,
        route: null,
        routePNNV: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        updateInputRows: false,
        addToTimeline: false,
        type: 'Titrate',
        isEkgImport: null,
        nemsisCode: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
      }
    default:
      return state
  }
}
